export const getApplications = (state) => state.applications


